import { acceptHMRUpdate, defineStore } from 'pinia'

const DEMO_BLOCKED_FEATURES = [
    'fields-table',
    'users-table',
    'trimble',
    'vehicles',
    'yieldmap',
    'as_applied',
    'latest_work_data',
]

export const useDemoStore = defineStore('demo', {
    state: () => ({
        demo: import.meta.env.VITE_DEMO,
    }),
    getters: {
        isDemo: (state) => state.demo === 'true',
    },
    actions: {
        isBlocked(feature) {
            return this.isDemo && DEMO_BLOCKED_FEATURES.includes(feature)
        },
    },
})

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useDemoStore, import.meta.hot))
}
